import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=1fe973b2&"
import script from "./file-upload.js?vue&type=script&lang=js&"
export * from "./file-upload.js?vue&type=script&lang=js&"
import style0 from "./file-upload.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports